export default __webpack_public_path__ + "static/media/MatiasFacio-portrait.224b3279.jpg";